export default "__VITE_ASSET__BPIfpjgN__";